import emailjs from '@emailjs/browser';

// Initialize EmailJS with your Public Key
// Option 1: Use environment variable (recommended for production)
// Option 2: Replace "YOUR_PUBLIC_KEY" with your actual key
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "YOUR_PUBLIC_KEY";
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "YOUR_SERVICE_ID";
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "YOUR_TEMPLATE_ID";

// Initialize EmailJS
emailjs.init(PUBLIC_KEY);

export const sendContactEmail = async (formData) => {
  // Validate that EmailJS is configured
  if (PUBLIC_KEY === "YOUR_PUBLIC_KEY" || SERVICE_ID === "YOUR_SERVICE_ID" || TEMPLATE_ID === "YOUR_TEMPLATE_ID") {
    console.error('EmailJS not configured. Please set up your credentials in emailService.js or .env file');
    return { 
      success: false, 
      message: 'Email service is not configured. Please contact the website administrator.' 
    };
  }

  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone || 'Not provided',
      subject: formData.subject || 'Contact Form Submission',
      message: formData.message,
      to_email: 'hardik2503@gmail.com', // Your business email
      to_name: 'Be Safe Keep Safe Team',
    };

    // Send email using EmailJS
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      templateParams
    );

    return { success: true, message: 'Email sent successfully!', response };
  } catch (error) {
    console.error('EmailJS Error:', error);
    return { 
      success: false, 
      message: 'Failed to send email. Please try again later.', 
      error: error.text || error.message 
    };
  }
};
